import { createFileRoute, redirect } from '@tanstack/react-router';

import { preLoadDefaultProject } from '@/lib/queries/project';

export const Route = createFileRoute('/_root/')({
  loader: async ({ context, location }) => {
    const project = await preLoadDefaultProject({ context });

    // Check if getting started is complete
    const isGettingStartedComplete = project.installedOnChannel === true;

    // Allow direct access to integrations from OAuth callbacks (bypasses getting-started guard)
    const searchString =
      typeof location.search === 'string'
        ? location.search
        : JSON.stringify(location.search);
    if (
      searchString.length > 0 &&
      (searchString.includes('github=') || searchString.includes('gitlab='))
    ) {
      throw redirect({ to: '/integrations', search: location.search });
    }

    // If getting started is not complete, redirect to getting started
    if (!isGettingStartedComplete) {
      throw redirect({ to: '/getting-started' });
    } else {
      // If getting started is complete, redirect to RCA
      throw redirect({ to: '/rca' });
    }
  },
});
